<cml-header
  [hasChanges]="hasChanges()"
  [saving]="saving()"
  [changeCount]="changeCount()"
  [hidePastEvents]="hidePastEvents()"
  [pastEventsCount]="pastEventsCount()"
  [searchTerm]="searchTerm()"
  (saveClick)="save()"
  (cancelClick)="cancel()"
  (togglePast)="togglePastEvents()"
  [hiddenPastSearchCount]="hiddenPastSearchCount()"
  (searchChange)="onSearchChange($event)"
  (clearSearch)="clearSearch()"
  (showPastResults)="showPastResults()"
  [availableLabels]="availableLabels()"
  [selectedLabels]="selectedLabels()"
  (toggleLabel)="toggleLabel($event)"
  [availableSchedules]="availableSchedules()"
  [selectedSchedule]="selectedSchedule()"
  [nowModeActive]="nowModeActive()"
  (selectSchedule)="selectSchedule($event)"
  (toggleNowMode)="toggleNowMode()"
/>

<div class="contTpl">
  @if (loading()) {
    <!-- Loader géré par .blocLoader global -->
  } @else if (events().length === 0) {
    <div class="txtnoev">
      Vous ne disposez d'aucun billet.<br><br>
      <span style="font-weight:800">Commencez par en créer depuis votre espace <a class="linkExt" href="https://app.wilout.com" target="_blank">Wilout ONLINE</a>.</span>
    </div>
  } @else {
    @if (filteredEvents().length === 0 && searchTerm()) {
      <div class="txtnoterm">
        <i class="far fa-info-circle"></i> &nbsp;Aucun résultat trouvé.<br><br>
        <span style="font-weight:800">Réessayer avec un autre mot clé.</span>
      </div>
    } @else if (filteredEvents().length === 0 && hidePastEvents() && pastEventsCount() > 0) {
      <div class="txtnoterm">
        <i class="far fa-info-circle"></i> &nbsp;Aucun événement actif.<br><br>
        <span style="font-weight:800">Activez le filtre « Événements passés » pour voir les {{ pastEventsCount() }} ancien{{ pastEventsCount() > 1 ? 's' : '' }} événement{{ pastEventsCount() > 1 ? 's' : '' }}.</span>
      </div>
    }
    <div class="contLiTpl">
      @for (event of filteredEvents(); track event._id) {
        <cml-event-accordion
          [event]="event"
          [expanded]="expandedEventIds().includes(event._id)"
          [expandedSourceType]="expandedSourceTypes()[event._id] ?? null"
          [configs]="tplConfigs()"
          [searchTerm]="searchTerm()"
          (toggleExpand)="toggleEvent($event)"
          (toggleAll)="toggleEventCheck(event)"
          (toggleSource)="toggleSource($event)"
          (sourceToggleAll)="toggleSourceCheck($event)"
          (tplToggle)="toggleTplCheck($event)"
          (tplNfcChange)="onNfcChangeFromChild($event)"
          (tplScanChange)="onScanChangeFromChild($event)"
          (tplColorChange)="onColorChangeFromChild($event)"
        />
      }
    </div>
  }
</div>
